import React, { lazy } from 'react';
import { createMemoryRouter } from 'react-router-dom';
import { routes } from 'router/routesConfig';

const Outlet = lazy(() =>
  import(/* webpackChunkName: "Outlet" */ 'widgets/topical-quiz/App/outlet')
);
const Init = lazy(() =>
  import(/* webpackChunkName: "Init" */ 'widgets/topical-quiz/App/pages/Init')
);

const Game = lazy(() => import(/* webpackChunkName: "Game" */ 'pages/Game'));

const Result = lazy(() => import(/* webpackChunkName: "Result" */ 'pages/Result'));

export const topicalRoutes = createMemoryRouter(
  [
    {
      element: <Outlet />,
      children: [
        {
          index: true,
          element: <Init />
        },
        {
          path: routes.game,
          children: [
            {
              index: true,
              element: <Game />
            },
            {
              path: routes.result,
              element: <Result />
            }
          ]
        }
      ]
    }
  ],
  {
    initialIndex: 0
  }
);
